import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-x-0 top-[calc(0.5rem+env(safe-area-inset-top,0px))] z-[55] mx-auto flex w-[calc(100%-1.5rem)] max-w-[480px] flex-wrap items-center gap-x-3 gap-y-2 rounded-lg border border-lightGray30 bg-white px-4 py-3 text-left text-[13px] text-textPrimary shadow-lg md:text-[14px]",
  role: "status",
  "aria-live": "polite",
  "data-testid": "app-update-notice"
}
const _hoisted_2 = {
  class: "h-5 w-5 shrink-0 text-primary",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  "aria-hidden": "true"
}
const _hoisted_3 = ["d"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "min-w-0 flex-1 max-md:basis-[calc(100%-2rem)]" }, "Saiu uma nova versão do Minha Escala.", -1)
const _hoisted_5 = { class: "ml-auto flex items-center gap-2" }

import { watch } from 'vue'
import { useRoute } from 'vue-router'
import { mdiUpdate } from '@mdi/js'

import { useAppVersionCheck } from '@/hooks/useAppVersionCheck'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppUpdateNotice',
  setup(__props) {

const route = useRoute()
const { updateAvailable, showUpdateNotice, dismiss, reloadApp, autoReloadForUpdate } =
  useAppVersionCheck()

// Posição: sempre no topo, centralizado. Embaixo ele disputava espaço com as barras fixas do
// dashboard no celular (semanas/zoom, seleção) e com a barra de gestos do Android.

// Telas sem operador (Modo TV) não têm quem clique: recarregam sozinhas (com trava anti-loop).
watch(
  updateAvailable,
  (available) => {
    if (available && route.meta.autoReloadOnUpdate) autoReloadForUpdate()
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_unref(showUpdateNotice))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createElementBlock("svg", _hoisted_2, [
          _createElementVNode("path", { d: _unref(mdiUpdate) }, null, 8, _hoisted_3)
        ])),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            class: "rounded px-3 py-1.5 text-[13px] font-medium text-primary hover:bg-primary5",
            "data-testid": "app-update-notice-dismiss",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(dismiss) && _unref(dismiss)(...args)))
          }, " Depois "),
          _createElementVNode("button", {
            type: "button",
            class: "rounded bg-primary20 px-3 py-1.5 text-[13px] font-medium text-white hover:bg-primary30",
            "data-testid": "app-update-notice-reload",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(reloadApp) && _unref(reloadApp)(...args)))
          }, " Atualizar agora ")
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})